import { Component } from '@angular/core'
import { IconButtonComponent, IconLegacyComponent, TooltipModule } from '@ftr/foundation'
import { featureFlag, LaunchDarklyModule } from '@ftr/ui-feature-flags'
import { HelpModule } from '@ftr/ui-help'
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap'
import { LogoSize, LogoTheme } from '../../types'
import { FtrLogoComponent } from '../ftr-logo'

@Component({
  selector: 'ftr-header-logged-out',
  templateUrl: './header-logged-out.component.html',
  styleUrls: ['./header-logged-out.component.css'],
  imports: [
    FtrLogoComponent,
    TooltipModule,
    IconLegacyComponent,
    LaunchDarklyModule,
    IconButtonComponent,
    HelpModule,
    NgbPopoverModule,
  ],
})
export class HeaderLoggedOutComponent {
  readonly logoThemes = LogoTheme
  readonly logoSizes = LogoSize

  isPublicNavigationEnabled = featureFlag('public-navigation')

  openHelpAndSupport(): void {
    // NOOP
  }
}
